var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    id: "plus-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0btjbh23wa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 573",
    transform: "translate(7413.17 1050.628)",
    style: {
      fill: "none"
    },
    d: "M0 0h21v21H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 38",
    transform: "translate(-7413.17 -1050.628)",
    style: {
      clipPath: "url(#0btjbh23wa)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11314"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5846",
    d: "M365.71 260.539h-6.717a2.512 2.512 0 0 1-.439-.027.837.837 0 0 1-.01-1.641 2.392 2.392 0 0 1 .439-.028h6.727v-6.666c0-.124 0-.249.008-.373a.842.842 0 0 1 1.68-.01 3.678 3.678 0 0 1 .01.373v6.672h6.717a2.527 2.527 0 0 1 .439.027.837.837 0 0 1 .01 1.641 2.635 2.635 0 0 1-.472.029H367.409V267.507a.846.846 0 1 1-1.692.01c-.007-.113 0-.226 0-.339v-6.138z",
    transform: "translate(7057.416 801.286) ",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/AddIcon.efdf19e54a2655f5d38bf2588a19de76.svg";
export { ForwardRef as ReactComponent };